import React from 'react'
import { inject, observer } from 'mobx-react'
import Name from '../common/Name'
import ExportKMZButton from 'components/common/tooltips/ExportKMZButton'
import MoveGeometryButton from 'components/common/tooltips/MoveGeometryButton'
import CopyGeometryButton from 'components/common/tooltips/CopyGeometryButton'
import DeleteItemPrompt from 'components/tools/item/DeleteItemPrompt'
import ErrorForm from '../common/ErrorForm'
import { withTranslation } from 'react-i18next'
import { startProCheckout } from '../../../proCheckout'
import ProBadge from 'components/common/ProBadge'
import { HugeiconsIcon } from '@hugeicons/react'
import {
  PencilEdit01Icon,
  PaintBoardIcon,
  CenterFocusIcon,
  Delete02Icon,
  Location01Icon
} from '@hugeicons/core-free-icons'

import RenameTooltip from 'components/common/tooltips/RenameTooltip'
import SaveEditShapeTooltip from 'components/common/tooltips/SaveEditShapeTooltip'

const SavedMarkerPane = ({
  savedMarker, group, uiStore, selectionStore, t
}) => {
  const isEditingThisMarker = selectionStore.isEditing && selectionStore.editableShape && (
    selectionStore.editableShape === savedMarker ||
    (savedMarker.id != null && selectionStore.editableShape.id != null && String(savedMarker.id) === String(selectionStore.editableShape.id))
  )
  const isShared = group && group.share_type && group.share_type !== 'none'
  const canManage = isShared
    ? !!(savedMarker && savedMarker.is_owner)
    : !!(group && group.is_owner)
  return (
    <div className='owned-geopolygon'>
      <section className='owned-geopolygon__list'>
        <Name label={t('GLOBAL.MARKER')} name={savedMarker.name} />
        {
          savedMarker.error &&
          !savedMarker.renameForm.active &&
            <ErrorForm item={savedMarker} />
        }
        {canManage && (
          isEditingThisMarker
            ? (
              <button
                className='edit-marker'
                onClick={(e) => {
                  e.stopPropagation()
                  uiStore.openClickTooltip({
                    allowMapClicks: true,
                    style: {
                      width: 340
                    },
                    position: 'right-start',
                    selector: '.tools.popup-menu',
                    text: (
                      <SaveEditShapeTooltip
                        title={t('GLOBAL.CONFIRM_SAVE', { defaultValue: 'Confirm Save' })}
                        itemName={savedMarker.name}
                        onSave={() => {
                          selectionStore.saveEdit()
                          uiStore.hideClickTooltip()
                        }}
                        onCancel={() => {
                          selectionStore.cancelEdit()
                          uiStore.hideClickTooltip()
                        }}
                        onClose={() => {
                          selectionStore.cancelEdit()
                          uiStore.hideClickTooltip()
                        }}
                      />
                    )
                  })
                }}
              >
                <HugeiconsIcon icon={Location01Icon} size={18} className='popup-menu__icon' />
                <span>{t('GLOBAL.CONFIRM_SAVE', { defaultValue: 'Save / Cancel' })}</span>
              </button>
              )
            : (
              <button
                className={`edit-marker ${uiStore.user && uiStore.user.type === 'starter' ? 'item-controls__disabled' : ''}`}
                onClick={(e) => {
                  e.stopPropagation()
                  if (uiStore.user && uiStore.user.type === 'starter') {
                    startProCheckout({ uiStore, t })
                    return
                  }
                  selectionStore.enableEdit(savedMarker, group)
                  uiStore.openClickTooltip({
                    allowMapClicks: true,
                    style: {
                      width: 340
                    },
                    position: 'right-start',
                    selector: '.tools.popup-menu',
                    text: (
                      <SaveEditShapeTooltip
                        title={t('ITEM.EDIT_MARKER', { defaultValue: 'Edit marker' })}
                        itemName={savedMarker.name}
                        onSave={() => {
                          selectionStore.saveEdit()
                          uiStore.hideClickTooltip()
                        }}
                        onCancel={() => {
                          selectionStore.cancelEdit()
                          uiStore.hideClickTooltip()
                        }}
                        onClose={() => {
                          selectionStore.cancelEdit()
                          uiStore.hideClickTooltip()
                        }}
                      />
                    )
                  })
                }}
              >
                <HugeiconsIcon icon={Location01Icon} size={18} className='popup-menu__icon' />
                <span>{t('ITEM.EDIT_MARKER', { defaultValue: 'Edit marker' })}</span>
                {uiStore.user && uiStore.user.type === 'starter' &&
                <ProBadge className='map-settings__pro text-small'>{t('GLOBAL.PRO')}</ProBadge>}
              </button>
              )
        )}
        {canManage && (
          <button
            className={`rename ${uiStore.user && uiStore.user.type === 'starter' ? 'item-controls__disabled' : ''}`}
            onClick={(e) => {
              e.stopPropagation()
              if (uiStore.user && uiStore.user.type === 'starter') {
                startProCheckout({ uiStore, t })
                return
              }
              uiStore.openClickTooltip({
                style: {
                  width: 340
                },
                position: 'right-start',
                selector: '.tools.popup-menu',
                text: (
                  <RenameTooltip
                    title={t('GLOBAL.RENAME_MARKER', { defaultValue: 'Rename marker' })}
                    label={t('GLOBAL.MARKER_NAME', { defaultValue: 'Marker name' })}
                    initialValue={savedMarker.name}
                    onSubmit={(newName) => {
                      if (typeof savedMarker.rename === 'function') {
                        savedMarker.rename(newName)
                      } else {
                        savedMarker.name = newName
                      }
                      uiStore.hideClickTooltip()
                    }}
                    onClose={() => {
                      uiStore.hideClickTooltip()
                    }}
                  />
                )
              })
            }}
          >
            <HugeiconsIcon icon={PencilEdit01Icon} size={18} className='popup-menu__icon' />
            <span>{t('GLOBAL.RENAME', { defaultValue: 'Rename' })}</span>
            {uiStore.user && uiStore.user.type === 'starter' &&
            <ProBadge className='map-settings__pro text-small'>{t('GLOBAL.PRO')}</ProBadge>}
          </button>
        )}
        <button onClick={e => {
          e.currentTarget.blur()
          uiStore.setBoundsToItem(savedMarker)
        }}
        >
          <HugeiconsIcon icon={CenterFocusIcon} size={18} className='popup-menu__icon' />
          <span>{t('GLOBAL.FIT_REGION')}</span>
        </button>
        {canManage && (
          <button
            className={`color-btn ${uiStore.user && uiStore.user.type === 'starter' ? 'item-controls__disabled' : ''}`}
            onClick={(e) => {
              if (uiStore.user && uiStore.user.type === 'starter') {
                startProCheckout({ uiStore, t })
                return
              }
              selectionStore.selectColorEdit(e, false)
            }}
          >
            <HugeiconsIcon icon={PaintBoardIcon} size={18} className='popup-menu__icon' />
            <span>{t('GLOBAL.COLOR')}</span>
            {uiStore.user && uiStore.user.type === 'starter' &&
            <ProBadge className='map-settings__pro text-small'>{t('GLOBAL.PRO')}</ProBadge>}
          </button>
        )}
        <CopyGeometryButton
          lgIcon
          group={group}
          onSubmit={() => uiStore.copyMarker(savedMarker, group)}
        />
        <MoveGeometryButton
          lgIcon
          group={group}
          onSubmit={() => uiStore.moveMarker(savedMarker, group)}
        />
        <ExportKMZButton lgIcon disabled={uiStore.user && uiStore.user.type === 'starter'} item={savedMarker} />
        {canManage && (
          <button
            className='delete'
            onClick={(e) => {
              e.stopPropagation()
              uiStore.openDeletePrompt({
                style: {
                  width: 340
                },
                position: 'right-start',
                selector: '.tools.popup-menu',
                text: (
                  <DeleteItemPrompt
                    item={group}
                    itemType='marker'
                    title={t('GLOBAL.DELETE_MARKER_Q', { defaultValue: 'Delete marker?' })}
                    itemName={savedMarker.name}
                    description={t('GLOBAL.DELETE_MARKER_DESC', { defaultValue: 'This marker and its saved data will be permanently removed.' })}
                    onSubmit={() => uiStore.deleteSavedMarker(group, savedMarker)}
                  />
                )
              })
            }}
          >
            <HugeiconsIcon icon={Delete02Icon} size={18} className='popup-menu__icon' />
            <span>{t('GLOBAL.DELETE')}</span>
          </button>
        )}
      </section>
    </div>
  )
}

export default withTranslation()(inject('uiStore', 'selectionStore')(observer(SavedMarkerPane)))
